import { createStore, applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import reducer from './reducer';
import rootSaga from './rootSaga';
import soundMiddleware from './middleware/soundMiddleware';
import config from './config';

export const history = createBrowserHistory({
    basename: config.APP_BASE_PATH,
});
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);

const middlewares = [routeMiddleware, sagaMiddleware, soundMiddleware];

export const store = createStore(
    connectRouter(history)(reducer),
    composeWithDevTools(applyMiddleware(...middlewares)),
);

sagaMiddleware.run(rootSaga);



// WEBPACK FOOTER //
// ./src/store.js